import { render, staticRenderFns } from "./ArticlesNews.vue?vue&type=template&id=1acd644a&scoped=true"
import script from "./ArticlesNews.vue?vue&type=script&lang=js"
export * from "./ArticlesNews.vue?vue&type=script&lang=js"
import style0 from "./ArticlesNews.vue?vue&type=style&index=0&id=1acd644a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1acd644a",
  null
  
)

export default component.exports